<template>
  <QCardSection class="p-0">
    <div class="flex items-center gap-8 p-24 pb-0">
      <q-icon
        size="1.25rem"
        color="primary-pure"
        name="svguse:#icon_award"
      />
      <h3 class="text-headline-3 text-neutral-100">
        {{ t('successCase') }}
      </h3>
    </div>

    <template v-if="alternativa.case_sucesso.length > 0">
      <q-list
        v-for="item in alternativa.case_sucesso"
        :key="item.id"
        class="w-full space-y-8 border-b border-neutral-100/10 px-24 py-16"
      >
        <OFileDownload
          :file="item.file_data"
          :name="item.file_data.nome_read"
        />
      </q-list>
    </template>
  </QCardSection>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import OFileDownload from 'components/FileUploader/OFileDownload.vue'

const { t } = useI18n()

const props = defineProps({
  alternativa: Object,
})
</script>

<style lang="scss" scoped></style>
